import RichText from '@/components/slices/richtext'
import Drawers from '@/components/slices/drawers'
import Message from '@/components/slices/message'
import Images from '@/components/slices/images'
import Documents from '@/components/slices/documents'
import Video from '@/components/slices/video'

export default {
  texte_riche: RichText,
  tiroirs: Drawers,
  message: Message,
  images: Images,
  documents: Documents,
  video: Video
}
